import { AssessmentQuestionInterface } from './assessment-question.model';

export interface AssessmentQuestionGroupInterface {
  id?: string;
  label?: string;
  questions?: AssessmentQuestionInterface[];
}

export class AssessmentQuestionGroup implements AssessmentQuestionGroupInterface {
  public id?: string;
  public label?: string;
  public questions?: AssessmentQuestionInterface[];

  constructor({
    id = undefined,
    label = undefined,
    questions = undefined,
    }: AssessmentQuestionGroupInterface) {
    this.id = id;
    this.label = label;
    this.questions = questions;
  }
}
